export enum CalendarSectionsEnum {
  events = '/calendar',
  bookings = '/calendar/bookings',
  availability = '/calendar/availability',
}

export enum CalendarSectionsLocoKeys {
  events = 'dashboard.calendar.title_events',
  bookings = 'dashboard.calendar.title_bookings',
  availability = 'dashboard.calendar.title_availability',
}
